import OperationalSystemEnum from "../entities/operational-system.enum";

class LocationTutorialCarouselService {
  public getUserOperationalSystem(): string {
    const { userAgent } = window.navigator;
    if (userAgent.includes('Iphone') || userAgent.includes('Mac')) {
      return OperationalSystemEnum.IOS;
    }
    return OperationalSystemEnum.ANDROID;
  }

  public getPhotosBySystem(system: string): string[] {
    const androidImages: string[] =
      [
        'assets/images/offline-tutorial/android/LOCATION_ANDROID_1.png',
        'assets/images/offline-tutorial/android/LOCATION_ANDROID_2.png',
        'assets/images/offline-tutorial/android/LOCATION_ANDROID_3.png',
        'assets/images/offline-tutorial/android/LOCATION_ANDROID_4.png',
      ];

    const iosImages: string[] =
      [
        'assets/images/offline-tutorial/ios/LOCATION_IOS_1.png',
        'assets/images/offline-tutorial/ios/LOCATION_IOS_2.png',
      ];

    switch (system) {
      case OperationalSystemEnum.ANDROID:
        return androidImages;
      case OperationalSystemEnum.IOS:
        return iosImages;
      default:
        return androidImages;
    }
  }
}

// eslint-disable-next-line import/no-anonymous-default-export
export default new LocationTutorialCarouselService();
